export default {
  apiKey: "AIzaSyBcDsuWcvTsLMB9FLkI01ddGPQhiJFCFCE",
  authDomain: "microgrid-90821.firebaseapp.com",
  databaseURL: "https://microgrid-90821.firebaseio.com",
  projectId: "microgrid-90821",
  storageBucket: "microgrid-90821.appspot.com",
  messagingSenderId: "500641904525",
  appId: "1:500641904525:web:1995ed6b3fef9925c92fc4"
}
